let lenisInstance = null;
export const setLenis = (l) => { lenisInstance = l; };

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenisInstance) lenisInstance.scrollTo(el, { offset: -72, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const CV_EN_URL = "/Ruiting_ZOU_IANG.pdf";
export const CV_CN_URL = "/Ruiting_ZOU_Bilingual.pdf";
export const ETSY_URL = "https://www.etsy.com/uk/shop/ZouneArtStudio";
export const LINKEDIN_URL = "https://linkedin.com/in/ruiting-zou";
export const EMAIL = "zouruitingtina@163.com";
export const EASE = [0.22, 1, 0.36, 1];
export const lenisToggle = (stop) => {
  if (!lenisInstance) return;
  if (stop) lenisInstance.stop();
  else lenisInstance.start();
};
